// colors.js
//363944
export const primary = 'rgb(54, 65, 68)'; // #364144
// $color1: rgb(16, 47, 47); // #102f2f
export const secondary = 'rgb(12, 103, 139)'; // #0c678b
export const tertiary = 'rgb(255, 115, 113)'; // #ff7371
export const quaternary = 'rgb(255, 237, 108)'; // #ffed6c
export const quinary = 'rgb(255, 251, 215)'; // #fffbd7    